 // LeftBar.js
 import React, {Component} from 'react';

 export default class LeftBar extends Component {
    constructor(props) {
        super(props);
        
                    const expandedSections = (() => {
                        try {
                            return JSON.parse(localStorage.getItem('leftbar_expanded') || '{}');
                        } catch (e) {
                            return {};
                        }
                    })();

                    this.state = {             
                        us_id: localStorage.getItem('us_id'),       
                        us_staff: localStorage.getItem('us_staff'),
                        us_admin: localStorage.getItem('us_admin'),                              
                        cl_id: localStorage.getItem('headerClientId'),
                        expandedSections
                    };

                    this.toggleSection = this.toggleSection.bind(this);
    }

        toggleSection(name){
            const expandedSections = Object.assign({}, this.state.expandedSections || {});
            expandedSections[name] = !expandedSections[name];
            this.setState({expandedSections}, () => {
                try{ localStorage.setItem('leftbar_expanded', JSON.stringify(this.state.expandedSections)); } catch(e){}
            });
        }
     render(){

        const link2 = '/mobile-order/'+this.state.cl_id;
        const link3 = '/scan-order/'+this.state.cl_id;

                const usLimited = localStorage.getItem('us_limited');
                
                if (usLimited === '1') {
                    return (
                        <div className="left-sidebar" >
                            <div className="scroll-sidebar">
                                <nav className="sidebar-nav">
                                    <ul id="sidebarnav">
                                        <li className="nav-devider"></li>
                                        <li> <a href="/products" aria-expanded="false">&nbsp;Products</a> </li>
                                        <li> <a href="/orders" aria-expanded="false">&nbsp;Orders</a> </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    )
                }

         return (
        
         <div className="left-sidebar" >
            
             <div className="scroll-sidebar">
             <nav className="sidebar-nav">
                <ul id="sidebarnav">                        
                    <li className="nav-devider"></li>
                                        <li className="nav-label" onClick={() => this.toggleSection('Products')} style={{cursor: 'pointer'}}>Products</li>                        
                                        { (this.state.expandedSections['Products'] !== false) && (
                                            <>
                                                <li> <a href="/products" aria-expanded="false">&nbsp;Products</a> </li>
                                                <li> <a href="/product-bins" aria-expanded="false">&nbsp;Locations</a> </li>
                                            </>
                                        )}
                                        {this.state.us_staff!=='1' ? (  
                                            <>
                                                <li className="nav-label" onClick={() => this.toggleSection('Incoming')} style={{cursor: 'pointer'}}>Incoming</li>
                                                { (this.state.expandedSections['Incoming'] !== false) && (
                                                    <>
                                                        <li> <a href="/receivers" aria-expanded="false">&nbsp;Receiving</a> </li>
                                                        <li> <a href="/returns" aria-expanded="false">&nbsp;Returns</a> </li>
                                                    </>
                                                )}
                                            </>
                                        ) : (<li></li>) }
                                        
                                        <li className="nav-label" onClick={() => this.toggleSection('Outgoing')} style={{cursor: 'pointer'}}>Outgoing</li>
                                        { (this.state.expandedSections['Outgoing'] !== false) && (
                                            <>
                                                <li> <a href="/orders" aria-expanded="false">&nbsp;Orders</a> </li>
                                                <li> <a href="/orders-amazon" aria-expanded="false">&nbsp;Expedite</a> </li>
                                                {this.state.us_staff!=='1' ? (  
                                                    <li> <a href="/pickups" aria-expanded="false">&nbsp;Pickups</a> </li>                        
                                                ) : (<li></li>) }
                                            </>
                                        )}

                    </ul>
                    {this.state.us_staff!=='1' ? (   
                    <div className="panel-heading">
                    <h4 className="panel-title">
                    <a data-toggle="collapse" href="#collapse1">Admin</a>
                    </h4>
                    </div>
                    ) : (<></>) }
                    
                    <div id="collapse1" className="panel-collapse collapse">                  
                    {this.state.us_staff !== '1' && (
                    <ul className="list-group">                            
                        <li><a href="/clients" aria-expanded="false">&nbsp;Clients</a></li>
                        <li><a href={link2} aria-expanded="false">&nbsp;Mobile</a></li>
                        <li><a href={link3} aria-expanded="false">&nbsp;Scanner</a></li>
                        <li><a href="/users" aria-expanded="false">&nbsp;Users</a></li>
                        <li><a href="/upload-volume" aria-expanded="false">&nbsp;Upload Volume</a></li>
                    </ul>
                    )}
                    </div>
                    {this.state.us_staff!=='1' ? ( 
                    <div className="panel-heading">
                        <h4 className="panel-title">
                        <a data-toggle="collapse" href="#collapse5">Reports</a>
                        </h4>
                    </div>
                    ) : (<div></div>) }
                    {this.state.us_staff!=='1' ? ( 
                    <div id="collapse5" className="panel-collapse collapse">
                        <ul className="list-group">
                            <li> <a href="/reports-billing" aria-expanded="false">&nbsp;Billing</a> </li>                            
                            <li> <a href="/reports-fulfillment" aria-expanded="false">&nbsp;Fulfillment</a> </li>
                            <li> <a href="/reports-inventory-log" aria-expanded="false">&nbsp;Inventory</a> </li>   
                            <li> <a href="/reports-inventory-blem" aria-expanded="false">&nbsp;Inventory Blem</a> </li>   
                            <li> <a href="/reports-item-billing" aria-expanded="false">&nbsp;Item Billing</a> </li>   
                            <li> <a href="/reports-item-volume" aria-expanded="false">&nbsp;Item Volume</a> </li>
                            <li> <a href="/reports-receiving" aria-expanded="false">&nbsp;Receiving</a> </li>
                            <li> <a href="/reports-order-status" aria-expanded="false">&nbsp;Order Scans</a> </li>
                        </ul>                   
                    </div>
                    ) : (<div></div>) }

               </nav>
             </div>
             
         </div>
        
                 )
     }
 }